import { Icon } from 'leaflet'
import markerIcon from '../../../../assets/img/marker-icon-3.svg'

const PinIcon = new Icon({
  iconUrl: markerIcon,
  iconSize: [50, 95],
  iconAnchor: [22, 94],
  popupAnchor: [-3, -76],
})

export default PinIcon
